const PartnersData = {}

  PartnersData.fenixevo = {
    "institutional": [
      {
        title: 'NOVA University',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2FNOVA%20UNI.png?alt=media&token=cbf5d98d-5d0b-4149-b79c-c2f3648dc58b',  
        link:'https://www.unl.pt/',
        tier: 'BIG'
      },
      {
        title: 'NOVA SST',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2Flogo_nova_fct_pt_v.png?alt=media&token=ed0015be-b061-4ebf-a3a8-3fd36fea20da',  
        link:'https://www.fct.unl.pt/',
        tier: 'BIG'
      },
      {
        title: 'AEFCT',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2FAE_peq.png?alt=media&token=ac1e28cb-4b32-44b6-967e-26339aa40c3a',  
        link:'https://ae.fct.unl.pt/',
        tier: 'Gold'
      },
      {
        title: 'DEMI',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2Fdemi.png?alt=media&token=7f3f7ebd-342d-4c36-9602-56450813a1df',  
        link:'https://www.demi.fct.unl.pt/',
        tier: 'Gold'
      },
      {
        title: 'DEEC',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2Fdeec.png?alt=media&token=3f67b690-e7d1-45e3-9c89-f3114e566ab0',  
        link:'https://www.dee.fct.unl.pt/',
        tier: 'Gold'
      },
    ],
      "gold": [
      {
        title: 'Bosch',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FBOSCH.png?alt=media&token=e97ca62e-40f0-46b4-aef4-e59946d03ea9',  
        link: 'https://www.bosch.pt/',
        tier: 'Gold'
      },
      {
        title: 'Ciclo Fapril',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FCICLOFABRIL.png?alt=media&token=deb52d06-4c0f-45a1-9d61-c5883ed9fe93',  
        link: 'https://ciclofapril.pt/pt/',
        tier: 'Gold'
      },
      {
        title: 'Cubotronic',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FCUBOTRONIC.png?alt=media&token=4a0a4294-37bc-454e-bdef-7389095f5156',  
        link: 'https://www.cubotonic.pt/',
        tier: 'Gold'
      },
      {
        title: 'Galp',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FGalp%20Logo%20-%20Main.png?alt=media&token=eca39b07-ce5c-4c8b-8ee2-a4d4b86a7026',
        link:'https://galp.com', 
        tier: 'Gold'
      },
      {
        title: 'MCG',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FMCG.svg?alt=media&token=9f0573d3-c103-4d4e-aeb4-aaa1a08edd2f',  
        link: 'https://www.mcg.pt/?lang=pt-pt',
        tier: 'Gold'
      },
      {
        title: 'VW Autoeuropa',
        imageUrl:'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FVW_Autoeuropa.png?alt=media&token=3c4029b6-e21d-4450-87a9-ede9dd1324c0',
        link:'https://www.volkswagenautoeuropa.pt/',
        tier:'Gold',
      }
    ],
    "silver": [
      {
        title: 'Altair',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FALTAIR.png?alt=media&token=32cb7b37-c59f-4eab-8454-bfc342eb64e5',  
        link:'https://altair.com/',
        tier: 'Silver'
      },
      {
        title: 'Althima',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FALTHIMA.svg?alt=media&token=0c5d6d6b-32b4-4f30-859f-aa504c60eb58',  
        link:'https://althima.com/',
        tier: 'Silver'
      },
      {
        title: 'Lean Acadamy',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FLEAN%20ACADEMY.png?alt=media&token=473d375c-c9b8-4b71-85ad-b7a4253579b2',  
        link: 'https://lean.org.pt/',
        tier: 'Silver'
      },
      {
        title: 'Leomavel',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FLEOMAVEL.jpg?alt=media&token=3c6dc439-ab8a-4248-b44b-c55a730ac43e',  
        link:'https://leomavel.pt/',
        tier: 'Silver'
      },
      {
        title: 'Rectimold',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FRECTIMOLD.png?alt=media&token=bb6cb8a7-0048-4b0e-9728-996408314d0b',  
        link:'https://rectimold.pt/en/',
        tier: 'Silver'
      },
      {
        title: 'TAP',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FTAP.png?alt=media&token=a43d8d53-5e1a-45b7-8ec9-c775d1e27b2c',  
        link:'https://www.flytap.com/',
        tier: 'Silver'
      },
      {
        title: 'Visteon',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FVISTEON.png?alt=media&token=8ac090c6-c164-4e76-ba10-4f111fc3f3f7',  
        link:'https://www.visteon.com/',
        tier: 'Silver'
      }
    ],
    "bronze": [
      {
        title: '3DISO',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2F3D%20ISO.png?alt=media&token=332b678b-1b68-4998-9965-5d69a8f67d3e',  
        link:'https://www.3d-iso.pt/',
        tier: 'Bronze'
      },
      {
        title: 'Alphayate',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FALPHAYATE.png?alt=media&token=d2fa237a-4b1e-4e64-bba5-070047c26020',  
        link:'https://www.alphayate.com/',
        tier: 'Bronze'
      },
      {
        title: 'Altium',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FALTIUM_DESIGNER.png?alt=media&token=1edfe1fc-5a07-4892-b286-dfce1b1fed25',  
        link:'https://www.altium.com/altium-designer',
        tier: 'Bronze'
      },
      {
        title: 'AMtita',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FAM%20TITA.jpg?alt=media&token=da8594e4-98b1-46d1-81de-a30d961f7b6b',  
        link:'https://www.amtita.pt/',
        tier: 'Bronze'
      },
      {
        title: 'Blocks',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FBLOCKS.png?alt=media&token=9d7854e4-5746-469f-96c4-17b800d2803a',  
        link:'https://blockstec.com/',
        tier: 'Bronze'
      },
      {
        title: 'Coficab',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FCOFICAB.png?alt=media&token=48ef6a45-1a98-4563-a4ed-2bdc0c180b1a',  
        link:'https://www.coficab.pt/',
        tier: 'Bronze'
      },
      {
        title: 'CortePratico',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FCORTE%20PRATICO.png?alt=media&token=81eb557a-4f57-4942-b7ab-3752d48c5271',  
        link:'https://cortepratico.pt/site/',
        tier: 'Bronze'
      },
      {
        title: 'DFC Turbo',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FDFC.png?alt=media&token=be6da4d5-efb8-4a80-83c9-4d79d864ba48',  
        link:'https://dfcturbo.com/',
        tier: 'Bronze'
      },
      {
        title: 'EXIDE',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FEXIDE.svg?alt=media&token=d92d1527-6315-4940-9ec1-f905cf338bd4',  
        link:'https://www.exidegroup.com/eu/pt',
        tier: 'Bronze'
      },
      {
        title: 'Fibran',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FFIBRAN.png?alt=media&token=0261c337-23c0-4e60-825b-0d6d5cc58168',  
        link: 'https://fibran.pt/',
        tier: 'Bronze'
      },
      {
        title: 'Fresatudo',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FFRESATUDO.jpg?alt=media&token=70c81d06-5542-42c3-b7ba-5d95cc6da9e4',  
        link:'https://www.fresatudo.pt/',
        tier: 'Bronze'
      },
      {
        title: 'KFRIO',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FKFRIO.png?alt=media&token=15b33cee-2c40-490e-8d32-c0c9e70b1498',  
        link:'https://kfrio.pt/',
        tier: 'Bronze'
      },
      {
        title: 'KIP',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FKIP.png?alt=media&token=31686522-3e3d-4537-b085-7f4f53df510f',  
        link:'https://kip.pt/',
        tier: 'Bronze'
      },
      {
        title: 'M3T',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FM3T.jpg?alt=media&token=cbe80291-b7ea-480d-9dda-567127bcde99',  
        link:'https://m3t.pt/',
        tier: 'Bronze'
      },
      {
        title: 'MATHWORKS',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FMATHWORKS.png?alt=media&token=f9901129-26a5-4a4f-983b-c63110396ce2',  
        link:'https://www.mathworks.com/',
        tier: 'Bronze'
      },
      {
        title: 'Maxiarte',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2Fcropped-Maxiarte_logo1.png?alt=media&token=626c9759-a65e-45de-b16b-c58f1e81bca1',  
        link: 'https://www.maxiarte.pt/',
        tier: 'Bronze'
      },
      {
        title: 'MCoutinho',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FMCOUTINHO.jpg?alt=media&token=07e0c111-fe78-4e28-b7b4-55cee78daf76',  
        link:'https://www.mcoutinho.pt/',
        tier: 'Bronze'
      },
      {
        title: 'NDTuned',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FNDTUNED.png?alt=media&token=37b866f8-2647-4a09-8133-70354fdf186e',  
        link:'https://www.ndtuned.com/',
        tier: 'Bronze'
      },
      {
        title: 'NGK',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FNGK.NITERRA.svg?alt=media&token=372e15e7-1c11-4b20-a6c2-4de07b564e75',  
        link:'https://ngksparkplugs.com/en/',
        tier: 'Bronze'
      },
      {
        title: 'NITERRA',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FNITERRA.png?alt=media&token=9f0d2dc3-456b-4629-9313-3ebadc6db717',  
        link:'https://www.ngkntk.com/pt/',
        tier: 'Bronze'
      },
      {
        title: 'Norelem',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FNORELEM.png?alt=media&token=85d4666b-02f1-476d-8dcb-1ba33d7e5f8d',  
        link: 'https://norelem.es/pt',
        tier: 'Bronze'
      },
      {
        title: 'PROSeat',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FPRO%20SEAT.png?alt=media&token=ac712749-524b-4965-a96c-7c17d6db1079',  
        link: 'https://proseat.eu/',
        tier: 'Bronze'
      },
      {
        title: 'RamadaAcos',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FRAMADA%20ACOS.png?alt=media&token=0e7a91ba-860b-4168-9474-4f7afb1a6bb2',  
        link: 'https://www.ramada.pt/',
        tier: 'Bronze'
      },
      {
        title: 'TeixeiraDuarte',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FLogo_TDGI.png?alt=media&token=6a3da3d1-367e-4b8c-a470-b946452f9be2',  
        link: 'https://www.tdgiworld.com/',
        tier: 'Bronze'
      },
      {
        title: 'ZDK',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FZDK.svg?alt=media&token=e375d0eb-f8fe-4d22-9103-373c08f3f66d',  
        link: 'https://www.zdkmotorsport.com/',
        tier: 'Bronze'
      }
    ]
  };

  PartnersData.ev01 = {
    "main": [
      {
        title: 'Reitoria',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2Froutezero_PT_negativo_stacked.svg?alt=media&token=d5855863-9472-48ed-8a3a-0235d74fa64b', 
        link: 'https://www.unl.pt/',
        tier: 'main'
      }
    ],
    "institutional": [
       {
        title: 'Reitoria',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2FnovaRouteZero.png?alt=media&token=3d68423a-233c-4172-91f6-6e4722ee23d7', 
        link: 'https://www.unl.pt/',
        tier: 'institutional'
      },
      {
        title: 'FCT',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2Flogo_nova_fct_pt_v.png?alt=media&token=ed0015be-b061-4ebf-a3a8-3fd36fea20da',
        link: 'https://www.fct.unl.pt/',
        tier: 'institutional'
      },
      {
        title: 'DEMI',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2Fdemi.png?alt=media&token=7f3f7ebd-342d-4c36-9602-56450813a1df',
        link: 'https://www.demi.fct.unl.pt/',
        tier: 'institutional'
      },
      {
        title: 'DEEC',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2Fdeec.png?alt=media&token=3f67b690-e7d1-45e3-9c89-f3114e566ab0',
        link: 'https://www.dee.fct.unl.pt/',
        tier: 'institutional'
      }
    ],
    "gold": [
      {
        title: 'JDEUS',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FJDEUS.png?alt=media&token=8d63fd1d-8f3b-414f-90a6-e3c4de286905',
        link: 'https://www.jdeus.com/AM',
        tier: 'gold'
      },
      {
        title: 'MCG',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FMCG.svg?alt=media&token=9f0573d3-c103-4d4e-aeb4-aaa1a08edd2f',
        link: 'https://www.mcg.pt/?lang=pt-pt',
        tier: 'gold'
      },
      {
        title: 'MPC',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FMPC.png?alt=media&token=6a212196-566d-444f-9a8a-6bd8d087fba4',
        link: 'https://mpcdesignworks.com/',
        tier: 'gold'
      },
      {
        title: 'TAP',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FTAP.png?alt=media&token=a43d8d53-5e1a-45b7-8ec9-c775d1e27b2c',
        link: 'https://www.flytap.com/',
        tier: 'gold'
      }
    ],
    "silver": [
      {
        title: 'Althima & Altair',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FALTHIMA.svg?alt=media&token=0c5d6d6b-32b4-4f30-859f-aa504c60eb58',
        link: 'https://althima.com/',
        tier: 'silver'
      },
      {
        title: 'CADFLOW',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FCADFLOW.png?alt=media&token=56f13e18-1f7f-463b-81dd-86c3bdff6585',
        link: 'https://www.cadflow.pt/',
        tier: 'silver'
      },
      {
        title: 'Lean Academy',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FLEAN%20ACADEMY.png?alt=media&token=473d375c-c9b8-4b71-85ad-b7a4253579b2',
        link: 'https://lean.org.pt/',
        tier: 'silver'
      },
      {
        title: 'Massivexpand',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FMASSIVEXPAND.png?alt=media&token=34415c44-785e-4bb1-8029-07a72fe6d473',
        link: 'https://pt.linkedin.com/company/massivexpand-unipessoal',
        tier: 'silver'
      },
      {
        title: 'Visteon',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FVISTEON.png?alt=media&token=8ac090c6-c164-4e76-ba10-4f111fc3f3f7',
        link: 'https://www.visteon.com/',
        tier: 'silver'
      }
    ],
    "bronze": [
      {
        title: 'About Energy',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FABOUTENERGY.png?alt=media&token=cff3ac2a-13be-4076-a8ba-aa5ad2a2a4b3',
        link: 'https://www.aboutenergy.io/',
        tier: 'bronze'
      },
      {
        title: 'Alphayate',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FALPHAYATE.png?alt=media&token=d2fa237a-4b1e-4e64-bba5-070047c26020',
        link: 'https://www.alphayate.com/',
        tier: 'bronze'
      },
      {
        title: 'BLOCKS',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FBLOCKS.png?alt=media&token=9d7854e4-5746-469f-96c4-17b800d2803a',
        link: 'https://blockstec.com/',
        tier: 'bronze'
      },
      {
        title: 'Coficab',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FCOFICAB.png?alt=media&token=48ef6a45-1a98-4563-a4ed-2bdc0c180b1a',
        link: 'https://www.coficab.pt/',
        tier: 'bronze'
      },
      {
        title: 'Fibran',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FFIBRAN.png?alt=media&token=0261c337-23c0-4e60-825b-0d6d5cc58168',
        link: 'https://fibran.pt/',
        tier: 'bronze'
      },
      {
        title: 'KIP',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FKIP.png?alt=media&token=31686522-3e3d-4537-b085-7f4f53df510f',
        link: 'https://kip.pt/',
        tier: 'bronze'
      },
      {
        title: 'Loctite',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FLOCTITE.png?alt=media&token=1c45723c-b4d6-4813-b50b-246fc67366f8',
        link: 'https://www.loctiteproducts.com/',
        tier: 'bronze'
      },
      {
        title: 'Mauser',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FMAUSER.png?alt=media&token=f37e2bd2-5786-4636-9696-3f575bbaf623',
        link: 'https://mauser.pt/',
        tier: 'bronze'
      },
      {
        title: 'MAXIARTE',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2Fcropped-Maxiarte_logo1.png?alt=media&token=626c9759-a65e-45de-b16b-c58f1e81bca1',
        link: 'https://www.maxiarte.pt/',
        tier: 'bronze'
      },
      {
        title: 'Norelem',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FNORELEM.png?alt=media&token=85d4666b-02f1-476d-8dcb-1ba33d7e5f8d',
        link: 'https://norelem.es/pt',
        tier: 'bronze'
      },
      {
        title: 'TE',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FTE.png?alt=media&token=a4597f39-33db-4907-ac98-49b04b4c3147',
        link: 'https://www.te.com/pt/home.html',
        tier: 'bronze'
      },
      {
        title: 'TELLES',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FTELLES.png?alt=media&token=9e9d87d3-1b60-4c20-8c43-e7e0ab8f753d',
        link: 'https://www.telles.pt/pt/',
        tier: 'bronze'
      },
      {
        title: 'Vector',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FVECTOR.png?alt=media&token=c780e887-c0ff-43ff-9fa7-6215775ba286',
        link: 'https://www.vector.com/int/en/',
        tier: 'bronze'
      },
      {
        title: 'Würth',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FWURTH.png?alt=media&token=ee0cc8e9-5f32-4ad9-be64-f2a4c9e22d0a',
        link: 'https://eshop.wurth.pt/pt/PT/EUR/',
        tier: 'bronze'
      }
    ],
    "partner": [
    {
      title: 'Altium',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FPartner%2FALTIUM.png?alt=media&token=141b15a8-879a-46de-92f3-cc619ee70695',
      link:'https://www.altium.com/',
      tier: 'partner'
    },
    {
      title: 'IPG Software',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FPartner%2FIPG.svg?alt=media&token=da95bbd6-e4a9-4db0-90c1-fae2b903b108',
      link:'https://www.ipg-automotive.com/',
      tier: 'partner'
    },
    {
      title: 'MATHWORKS',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FMATHWORKS.png?alt=media&token=f9901129-26a5-4a4f-983b-c63110396ce2',  
      link:'https://www.mathworks.com/',
      tier: 'partner'
    },
    {
      title: 'Rapid Harness',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FPartner%2FRAPID_HARNESS.png?alt=media&token=b11341ac-2248-4d6e-af8e-44b49c630a40',
      link:'https://rapidharness.com/',
      tier: 'partner'
    },
    {
      title: 'SolidWorks',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FPartner%2FSOLIDWORKS.svg?alt=media&token=e43aa96d-9e6a-4eba-9583-2f0c5de52767',
      link:'https://www.solidworks.com/',
      tier: 'partner'
    },
    {
      title: 'TESLA',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FTESLA.png?alt=media&token=f90d672d-4446-4044-8e2b-444c46455bd8',
      link: 'https://www.tesla.com/',
      tier: 'partner'
    },
    {
      title: 'Trigenius',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FPartner%2FTRIGENIUS.svg?alt=media&token=24266613-6307-4cfd-b94a-a092d7fc890e',
      link:'https://trigenius.pt/',
      tier: 'partner'
    },
    {
      title: 'VI-Grade',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSoftware%2FVI-GRADE.jpg?alt=media&token=0ba9de7a-94d5-43c1-983f-f70912c2f007',
      link: 'https://www.vi-grade.com',
      tier: 'partner'
    },
  ]
  };

PartnersData.allPartners = {
  "institutional": [
    {
      title: 'NOVA Route Zero',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2FnovaRouteZero.png?alt=media&token=3d68423a-233c-4172-91f6-6e4722ee23d7',
      link:'https://www.unl.pt/',
      tier: 'institutional'
    },
    {
      title: 'NOVA SST',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2Flogo_nova_fct_pt_v.png?alt=media&token=ed0015be-b061-4ebf-a3a8-3fd36fea20da',
      link:'https://www.fct.unl.pt/',
      tier: 'institutional'
    },
    {
      title: 'AEFCT',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2FAE_peq.png?alt=media&token=ac1e28cb-4b32-44b6-967e-26339aa40c3a',
      link:'https://ae.fct.unl.pt/',
      tier: 'institutional'
    },
    {
      title: 'DEMI',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2Fdemi.png?alt=media&token=7f3f7ebd-342d-4c36-9602-56450813a1df',
      link:'https://www.demi.fct.unl.pt/',
      tier: 'institutional'
    },
    {
      title: 'DEEC',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FInstitucional%2Fdeec.png?alt=media&token=3f67b690-e7d1-45e3-9c89-f3114e566ab0',
      link:'https://www.dee.fct.unl.pt/',
      tier: 'institutional'
    },
  ],
  "gold": [
    {
      title: 'AES Molds',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FAES-MOLDS.png?alt=media&token=1f7b6f4b-de8c-4970-9cd9-c11e19f7a8ef',
      link: 'https://www.aesmolds.com/',
      tier: 'gold'
    },
    {
      title: 'JDEUS',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FJDEUS.png?alt=media&token=8d63fd1d-8f3b-414f-90a6-e3c4de286905',
      link: 'https://www.jdeus.com/AM',
      tier: 'gold'
    },
    {
      title: 'MCG',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FMCG.svg?alt=media&token=9f0573d3-c103-4d4e-aeb4-aaa1a08edd2f',
      link: 'https://www.mcg.pt/?lang=pt-pt',
      tier: 'gold'
    },
    {
      title: 'MPC',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FMPC.png?alt=media&token=6a212196-566d-444f-9a8a-6bd8d087fba4',
      link: 'https://mpcdesignworks.com/',
      tier: 'gold'
    },
    {
      title: 'NOS',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FGold%2FNOS.svg?alt=media&token=14ec9b7a-b460-411a-b897-dbcfb69c8247',
      link: 'https://www.nos.pt/',
      tier: 'gold'
    },
    {
      title: 'TAP',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FTAP.png?alt=media&token=a43d8d53-5e1a-45b7-8ec9-c775d1e27b2c',
      link: 'https://www.flytap.com/',
      tier: 'gold'
    },
  ],

  "silver": [
    {
      title: 'Althima',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FALTHIMA.svg?alt=media&token=0c5d6d6b-32b4-4f30-859f-aa504c60eb58',
      link:'https://althima.com/',
      tier: 'silver'
    },
    {
      title: 'CADFLOW',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FCADFLOW.png?alt=media&token=56f13e18-1f7f-463b-81dd-86c3bdff6585',
      link: 'https://www.cadflow.pt/',
      tier: 'silver'
    },
    {
      title: 'Lean Acadamy',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FLEAN%20ACADEMY.png?alt=media&token=473d375c-c9b8-4b71-85ad-b7a4253579b2',  
      link: 'https://lean.org.pt/',
      tier: 'Silver'
    }, 
    {
      title: 'Visteon',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSilver%2FVISTEON.png?alt=media&token=8ac090c6-c164-4e76-ba10-4f111fc3f3f7',  
      link:'https://www.visteon.com/',
      tier: 'Silver'
    },
  ],
  
  "bronze": [
    {
      title: 'About Energy',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FABOUTENERGY.png?alt=media&token=cff3ac2a-13be-4076-a8ba-aa5ad2a2a4b3',
      link: 'https://www.aboutenergy.io/',
      tier: 'bronze'
    },
    {
      title: 'Alphayate',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FALPHAYATE.png?alt=media&token=d2fa237a-4b1e-4e64-bba5-070047c26020',
      link: 'https://www.alphayate.com/',
      tier: 'bronze'
    },
    {
      title: 'BLOCKS',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FBLOCKS.png?alt=media&token=9d7854e4-5746-469f-96c4-17b800d2803a',
      link: 'https://blockstec.com/',
      tier: 'bronze'
    },
    {
      title: 'Coficab',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FCOFICAB.png?alt=media&token=48ef6a45-1a98-4563-a4ed-2bdc0c180b1a',
      link: 'https://www.coficab.pt/',
      tier: 'bronze'
    },
    {
      title: 'Critical TechWorks',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FCRITICAL_TECHWORKS.svg?alt=media&token=234f58e9-057d-4324-bf9a-91e6bfdb83b7',
      link: 'https://www.criticaltechworks.com/',
      tier: 'bronze'
    },
    {
      title: 'Filkemp',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FFILKEMP.png?alt=media&token=e07c8415-36a1-40a4-ba92-56a6d6a5a601',
      link: 'https://www.filkemp.pt/',
      tier: 'bronze'
    },
    {
      title: 'Loctite',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FLOCTITE.png?alt=media&token=1c45723c-b4d6-4813-b50b-246fc67366f8',
      link: 'https://www.loctiteproducts.com/',
      tier: 'bronze'
    },
    {
      title: 'Mauser',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FMAUSER.png?alt=media&token=f37e2bd2-5786-4636-9696-3f575bbaf623',
      link: 'https://mauser.pt/',
      tier: 'bronze'
    },
    {
      title: 'Norelem',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FNORELEM.png?alt=media&token=85d4666b-02f1-476d-8dcb-1ba33d7e5f8d',
      link: 'https://norelem.es/pt',
      tier: 'bronze'
    },
    {
      title: 'TE',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FTE.png?alt=media&token=a4597f39-33db-4907-ac98-49b04b4c3147',
      link: 'https://www.te.com/pt/home.html',
      tier: 'bronze'
    },
    {
      title: 'TELLES',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FTELLES.png?alt=media&token=9e9d87d3-1b60-4c20-8c43-e7e0ab8f753d',
      link: 'https://www.telles.pt/pt/',
      tier: 'bronze'
    },
    {
      title: 'Würth',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FWURTH.png?alt=media&token=ee0cc8e9-5f32-4ad9-be64-f2a4c9e22d0a',
      link: 'https://eshop.wurth.pt/pt/PT/EUR/',
      tier: 'bronze'
    },
  ],
  
  "partner": [
    {
      title: 'Altium',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FPartner%2FALTIUM.png?alt=media&token=141b15a8-879a-46de-92f3-cc619ee70695',
      link:'https://www.altium.com/',
      tier: 'partner'
    },
    {
      title: 'IPG Software',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FPartner%2FIPG.svg?alt=media&token=da95bbd6-e4a9-4db0-90c1-fae2b903b108',
      link:'https://www.ipg-automotive.com/',
      tier: 'partner'
    },
    {
      title: 'MATHWORKS',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FMATHWORKS.png?alt=media&token=f9901129-26a5-4a4f-983b-c63110396ce2',  
      link:'https://www.mathworks.com/',
      tier: 'partner'
    },
    {
      title: 'Rapid Harness',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FPartner%2FRAPID_HARNESS.png?alt=media&token=b11341ac-2248-4d6e-af8e-44b49c630a40',
      link:'https://rapidharness.com/',
      tier: 'partner'
    },
    {
      title: 'SolidWorks',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FPartner%2FSOLIDWORKS.svg?alt=media&token=e43aa96d-9e6a-4eba-9583-2f0c5de52767',
      link:'https://www.solidworks.com/',
      tier: 'partner'
    },
    {
      title: 'TESLA',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FBronze%2FTESLA.png?alt=media&token=f90d672d-4446-4044-8e2b-444c46455bd8',
      link: 'https://www.tesla.com/',
      tier: 'partner'
    },
    {
      title: 'Trigenius',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FPartner%2FTRIGENIUS.svg?alt=media&token=24266613-6307-4cfd-b94a-a092d7fc890e',
      link:'https://trigenius.pt/',
      tier: 'partner'
    },
    {
      title: 'VI-Grade',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Sponsors%2FSoftware%2FVI-GRADE.jpg?alt=media&token=0ba9de7a-94d5-43c1-983f-f70912c2f007',
      link: 'https://www.vi-grade.com',
      tier: 'partner'
    },
  ]
};


export default PartnersData;  